<template>
    <div>
        {{ getType() }}
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong> had its integration channel visibility-->
<!--        changed by <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.channelVisibilityChanged', {channel: $_.get(activity, 'payload.name'), user: $_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChannelVidibilityChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getType() {
            return {
                "whatsapp-business-api": " Whatsapp Business API",
                telegram: "Telegram",
                "whatsapp-qr": "Whatsapp V1",
                "whatsapp-v2": "Whatsapp V2",
                "sms-postacell": "SMS Postacell",
                openai: "OpenAI",
            }[this.activity.payload.type];
        },
    },
});
</script>

<style scoped lang="scss"></style>
